import React from 'react';
import { SparklesIcon, PlusIcon } from 'lucide-react';
interface EmbeddingsViewProps {
  userPlan: string;
}
export function EmbeddingsView({
  userPlan
}: EmbeddingsViewProps) {
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-297">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-298">
        <div data-id="element-299">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-300">Embeddings</h2>
          <p className="text-sm text-gray-600 mt-1" data-id="element-301">
            Manage vector embeddings for semantic search and AI understanding
          </p>
        </div>
        <button disabled={userPlan === 'Free'} className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-302">
          <PlusIcon className="w-4 h-4" data-id="element-303" />
          Generate Embeddings
        </button>
      </div>
      {/* Content placeholder */}
      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center" data-id="element-304">
        <SparklesIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-305" />
        <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-306">
          Embedding Management
        </h3>
        <p className="text-sm text-gray-600 max-w-md mx-auto" data-id="element-307">
          {userPlan === 'Free' ? 'This is a read-only demo. Upgrade to generate and manage embeddings.' : 'Generate and manage vector embeddings to power semantic search and AI understanding.'}
        </p>
      </div>
    </div>;
}